module.exports = "/_next/static/images/teamDescriptionBgPhoto-3118ae05c6b037995e9062b8201f5d75.webp";